import React from 'react';

export const TemplatesTableEmpty: React.FC = () => {
  return (
    <div className="text-center py-12">
      <div className="text-gray-500">No templates found. Create your first template to get started.</div>
    </div>
  );
};
